import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';

const CrewFilter = ({ handleFilters, filters }) => {
	const [checkedInFilter, setCheckedInFilter] = useState(null);

	const location = useLocation();
	const navigate = useNavigate();


	useEffect(() => {
		setFiltersFromURL();
	}, []);

	const entryCheckedInOptions = [
		{ value: '', label: 'All' },
		{ value: 1, label: 'Registered' },
		{ value: 0, label: 'Not Registered' },
	];

	const findOptionLabel = (options, value) => {
		if (!options) return value;
		const intValue = isNaN(value) ? value : parseInt(value, 10);
		const option = options.find((option) => option.value === intValue);
		return option ? option.label : value;
	};

	const getFilterState = (options, value) => {
		if (!value) return null;
		return { value, label: findOptionLabel(options, value) };
	};

	const setFiltersFromURL = () => {
		const searchParams = new URLSearchParams(location.search);
		const newFilters = {
			checkedIn: getFilterState(entryCheckedInOptions, searchParams.get('checkedIn')),
		};
		console.log(newFilters);
		setCheckedInFilter(newFilters.checkedIn);
		handleFilters(newFilters);
	};

	const updateURLParams = (newFilters) => {
		const searchParams = new URLSearchParams(location.search);
		Object.keys(newFilters).forEach((key) => {
			if (newFilters[key]) {
				searchParams.set(key, newFilters[key].value);
			} else {
				searchParams.delete(key);
			}
		});
		navigate({ search: searchParams.toString() });
	};

	const handleCheckedInChange = (selectedOption) => {
		const newCheckedIn = selectedOption.value === '' ? null : selectedOption;
		setCheckedInFilter(newCheckedIn);
		const newFilters = { ...filters, checkedIn: newCheckedIn };
		handleFilters(newFilters);
		updateURLParams(newFilters);
	};

	return (
		<div className="filter-container row">
			<div className="filter-item col-12 col-md-6 mb-3">
				<label>Crew registered</label>
				<Select value={filters.checkedIn} onChange={handleCheckedInChange} options={entryCheckedInOptions} />
			</div>
		</div>
	);
};

export default CrewFilter;
